import * as R from 'ramda'
import {Decoder, equal, oneOf} from 'json-bouncer'

export type M =
    | 'Canceled'
    | 'PriceSubmissionPossible'
    | 'WaitingForAssignment'
    | 'Assigned'
    | 'NotAssigned'
    | 'Inactive'
    | 'Declined'
    | 'Ordered'

export function all(): M[] {
    return [
        'Canceled',
        'PriceSubmissionPossible',
        'WaitingForAssignment',
        'Assigned',
        'NotAssigned',
        'Inactive',
        'Declined',
        'Ordered'
    ]
}

export function decoder(): Decoder<M> {
    return oneOf(R.map<M, Decoder<M>>(equal, all()))
}

export function label(status: M): string {
    switch (status) {
        case 'Canceled':
            return 'Storniert'
        case 'PriceSubmissionPossible':
            return 'Preisabgabe möglich'
        case 'WaitingForAssignment':
            return 'Warte auf Zuteilung'
        case 'Assigned':
            return 'Zuteilung erhalten'
        case 'NotAssigned':
            return 'Zuteilung nicht erhalten'
        case 'Inactive':
            return 'Inaktiv'
        case 'Declined':
            return 'Abgelehnt'
        case 'Ordered':
            return 'Bestellung erhalten'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaManufacturerStatus.ts